import i18n from '@/locales/i18n';
import SMHSDK from '@/renderer/scripts/libs/smh-sdk-class';
import { showLog } from '@/renderer/scripts/utils/tools/index';
import { IS_BROWSER } from '@/common/constant/index';
import meeting from '@/renderer/scripts/utils/meeting';
import { getProxyConfigFromStorage } from '@/renderer/scripts/proxy';
import { httpUrl } from '@/renderer/scripts/http';
import systemClock from '@/common/SystemClock';
import cancelRequest from './cancel';

const smh = new SMHSDK({
  baseURL: httpUrl.SMHUrl,
  envType: IS_BROWSER ? 'web' : 'node',
  proxy: getProxyConfigFromStorage(), // 在smh初始化的时候，就从storage中读取一次配置，若随后又改变，则会调用changeConfig
});

httpUrl
  .on(httpUrl.EVENT_MAP.SMHHostInit, () => {
    smh.changeConfig({
      baseURL: httpUrl.SMHUrl,
    });
  })
  .on(httpUrl.EVENT_MAP.SMHHostChanged, () => {
    smh.changeConfig({
      baseURL: httpUrl.SMHUrl,
    });
  });

// 日志落盘
smh.on('request', ({ config }) => {
  if (meeting.isTMWebview) {
    // 腾讯会议内所有接口增加参数
    config.params.pf = 'meeting';
  }
  if (config.headers) {
    config.headers['Accept-TCED-Language'] = i18n.locale;
  }

  // TODO: 白名单机制：此处暂时只对空间列表相关的api进行取消。
  if (
    config.cancelToken === undefined &&
    // 以下为空间切换时发送的请求API名
    ['listDirectory', 'getTeamSpace', 'getDynamics', 'getFileExtraInfo'].includes(
      config.customAttributes?.apiName || '',
    )
  ) {
    config.cancelToken = cancelRequest.token;
  }

  config.starttime = Date.now();
  const logParams = showLog('SMH request', null, null, config);
  logParams && logger.smh(...logParams);
});
smh.on('response', res => {
  const { config, data, error } = res;
  if (config) config.endtime = Date.now();
  if (data?.headers?.date || error?.headers?.date) {
    // 根据请求返回的服务器时间校准本地时间
    systemClock.handleOffset(data?.headers.date || error?.headers?.date);
  }
  const logParams = showLog('SMH response', error, data, config);
  logParams && logger.smh(...logParams);
});
export default smh;
